
import XHeader from 'vux/src/components/x-header/index.vue'
import Badge from 'vux/src/components/badge/index.vue'
import Range from 'vux/src/components/range/index.vue'


import Progresss from '@/components/prog/Progresshelp'
export default {
name: 'assistitem',
components: {XHeader, Badge, Range,Progresss},






props: ['item', 'type'],
data () {
return {
data1: 50,
itemdata: null
}
},
computed:{

},
methods: {
asd(item){
if(item.alreadyMoney==0){
return 0
}else if((parseFloat(item.alreadyMoney)/parseFloat(item.planMoney)*100).toFixed(1)<=0.1){
console.log('-----------')
return '0.1'
}else{
return (parseFloat(item.alreadyMoney)/parseFloat(item.planMoney)*100).toFixed(1)
}
},
total (moneycount, target_amount) {
console.log(moneycount, '------', target_amount)
return moneycount / target_amount * 100
},
todetail (item) {

this.$router.push('/zcprojectDetail/'+item.acr001+'/'+this.G("zcuserid")+'/'+this.G("zcnickname")+'/null')
},



name (str) {
if(str == null || str ==''){
return  '案说法'
}else if (str.length === 2) {
return str.substring(0, 1) + '*' + str.substring(1)
} else {
return str.substring(0, 1) + '*' + str.substring(2)
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/assist/zcassistitem.vue